/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserStatusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABjklEQVR4nOVUTUrDQBiNK0EQQXCn664UBA/gRiia7yeL4fuqB9GFOynoCbyCLQVPUKuCV/AGli5UtPVnI63MtNZImiYh6cqBt8rMe2/e9zKe9y8WkawhSwNYuxbIcoloSoWRA+kTsg7+Qp7tt9wCyNKIko9AWs8tAC6SGAGW15kKAOlLbgG0A42NSGr5BdCU7ECj7uUxCA5WvcJqSlq3mTuQ1Aojn+myLoHkEFhvgOUBSL+GkDaw3iLLkTFmOTNxuVyeR5YzJPmMr6iraYdofz0buTErwHo3nVhdg4wxS5mdpyEH1gvP8+bsGWAhJLlGljcLYG0RVWCigIslyTlLBxEXh/v1dMreamSgyZmrxfHYeeJNxR8L2LakIB8A6IZz72JJjPLqV8DVbvzG3Mcd8n1/YWhIeykEuuEbtEfkPSLZLkIAw68tkH6M3pjzaQKIujm6cStFlZuhBrlGvCPqFgS6g6z9CYf6RJVdu99WMVEg0L1M/0m01lqNzZ/kJBf5z7JVtG2xM3FzIWmGnX8DVi/ldTtJbUwAAAAASUVORK5CYII=)
 */
export const UserStatusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM2 20.53A9.53 9.53 0 0 1 11.53 11h.94c1.28 0 2.5.25 3.61.7.41.18.36.77-.05.96a7 7 0 0 0-3.65 8.6c.11.36-.13.74-.5.74H6.15a.5.5 0 0 1-.5-.55l.27-2.6c.02-.26-.27-.37-.41-.16-.48.74-1.03 1.8-1.32 2.9a.53.53 0 0 1-.5.41h-.22C2.66 22 2 21.34 2 20.53Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M24 19a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
        className={colorClass}
      />
    </svg>
  );
};
